import { initProjectsSplide } from './_splideInit';

export function projectFilter() {
  const filterButtons = document.querySelectorAll('.c-portfolio__filter-btn');
  const projectCards = document.querySelectorAll('.splide__slide');
  const splideList = document.querySelector('.p-top-projects__splide .splide__list');
  const splideContainer = document.querySelector('.p-top-projects__splide');

  if (filterButtons.length === 0) {
    return;
  }

  // Ajax機能が利用可能かチェック（トップページと事業領域ページ）
  const isAjaxMode = window.portfolioAjax && (document.getElementById('top') || document.getElementById('business-field'));

  if (!isAjaxMode && projectCards.length === 0) {
    return;
  }

  // ページごとに異なるキーを使用（現在のページパスを基に）
  const storageKey = `projectFilter_${window.location.pathname}`;

  // ローディング表示関数
  function showLoading() {
    if (splideList) {
      splideList.innerHTML = '<div class="loading" style="display: flex; justify-content: center; align-items: center; height: 300px; width: 100%;">読み込み中...</div>';
    }
  }

  // Ajax フィルタリング実行関数
  function applyAjaxFilter(filterCategory) {
    // アクティブ状態を切り替え
    updateFilterUI(filterCategory);

    // ローディング表示
    showLoading();

    // Ajax通信
    const formData = new FormData();
    formData.append('action', 'portfolio_filter');
    formData.append('category', filterCategory);
    formData.append('nonce', window.portfolioAjax.nonce);

    fetch(window.portfolioAjax.ajaxurl, {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        // スライドを置き換え
        if (splideList) {
          splideList.innerHTML = data.posts;
        }
        
        // Splideを再初期化
        if (splideContainer) {
          // 既存のSplideインスタンスを破棄
          if (splideContainer.splide) {
            splideContainer.splide.destroy();
          }

          // 既存の初期化関数を再利用
          setTimeout(() => {
            // インポートした関数を直接呼び出し
            initProjectsSplide();
          }, 100);
        }

        // sessionStorageに状態を保存
        try {
          if (filterCategory !== 'all') {
            sessionStorage.setItem(storageKey, filterCategory);
          } else {
            sessionStorage.removeItem(storageKey);
          }
        } catch (e) {
          // sessionStorage が使用できない場合は何もしない
        }
      } else {
        if (splideList) {
          splideList.innerHTML = '<div class="error" style="display: flex; justify-content: center; align-items: center; height: 300px; width: 100%;">エラーが発生しました</div>';
        }
      }
    })
    .catch(error => {
      console.error('Error:', error);
      if (splideList) {
        splideList.innerHTML = '<div class="error" style="display: flex; justify-content: center; align-items: center; height: 300px; width: 100%;">エラーが発生しました</div>';
      }
    });
  }

  // UI更新関数
  function updateFilterUI(filterCategory) {
    filterButtons.forEach(btn => btn.classList.remove('is-active'));
    const targetButton = document.querySelector(`[data-category="${filterCategory}"]`);
    if (targetButton) {
      targetButton.classList.add('is-active');
      
      // スマホのアコーディオンのラベルを更新
      const currentLabel = document.querySelector('.c-portfolio__filter-current');
      if (currentLabel) {
        currentLabel.textContent = targetButton.textContent;
      }
    }
  }

  // 従来のフィルタリング実行関数（アーカイブページ用）
  function applyFilter(filterCategory, updateUI = true) {
    if (updateUI) {
      updateFilterUI(filterCategory);
    }

    // フィルタリング実行
    projectCards.forEach(card => {
      if (filterCategory === 'all') {
        // ALLの場合は全て表示
        card.style.display = 'block';
      } else {
        // カテゴリーが一致するかチェック
        const cardCategories = card.getAttribute('data-categories');
        if (cardCategories && cardCategories.includes(filterCategory)) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
      }
    });

    // Splideが存在する場合は更新
    if (splideContainer && splideContainer.splide) {
      // Splideの再描画を実行
      splideContainer.splide.refresh();
    }

    // sessionStorageに状態を保存（ページ別）
    try {
      if (filterCategory !== 'all') {
        sessionStorage.setItem(storageKey, filterCategory);
      } else {
        sessionStorage.removeItem(storageKey);
      }
    } catch (e) {
      // sessionStorage が使用できない場合は何もしない
    }
  }

  // ページ読み込み時にsessionStorageから状態を復元
  function restoreFilterFromStorage() {
    try {
      const savedFilter = sessionStorage.getItem(storageKey);
      if (savedFilter) {
        // 保存されたカテゴリに該当するボタンがあるかチェック
        const targetButton = document.querySelector(`[data-category="${savedFilter}"]`);
        if (targetButton) {
          // Ajax mode か従来モードかを判定して実行
          if (isAjaxMode) {
            applyAjaxFilter(savedFilter);
          } else {
            applyFilter(savedFilter, true);
          }
          return;
        }
      }
    } catch (e) {
      // sessionStorage が使用できない場合は何もしない
    }
    // デフォルトはALL
    if (isAjaxMode) {
      applyAjaxFilter('all');
    } else {
      applyFilter('all', true);
    }
  }

  // フィルターボタンのクリックイベント
  filterButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      
      const filterCategory = button.getAttribute('data-category');
      
      // アコーディオンを閉じる（スマホ用）
      const filterMenu = document.querySelector('.c-portfolio__filter-menu');
      const filterToggle = document.querySelector('.c-portfolio__filter-toggle');
      if (filterMenu && filterToggle) {
        filterMenu.classList.remove('is-open');
        filterToggle.classList.remove('is-active');
      }

      // Ajax mode か従来モードかを判定して実行
      if (isAjaxMode) {
        applyAjaxFilter(filterCategory);
      } else {
        applyFilter(filterCategory, true);
      }
    });
  });

  // 初期化時に状態を復元
  restoreFilterFromStorage();
}